import React, { FC } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
import { Image } from '../../molecules/Image/render';
import block from './block.json';
import { getStyles } from './styles.css';

export type PageHeaderProps = {
	variant?: string;
	title: string;
	backgroundImage?: ImageProps;
} & ThemeProps;

export const PageHeader: FC<PageHeaderProps> & BlockConfigs = ({
	title,
	backgroundImage,
	variant: currentVariant = 'default',
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(
		block.slug,
		theme,
		currentVariant
	);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx(
		'supt-pageHeader supt-pageHeaderFull',
		`supt-pageHeader--${variant}`,
		getStyles(blockTheme)
	);

	return (
		<div className={rootClass} data-block={block.slug} {...htmlProps}>
			<div className="supt-pageHeaderFull__inner">
				<h1
					className="supt-pageHeaderFull__title"
					dangerouslySetInnerHTML={{ __html: title }}
				/>
			</div>

			{backgroundImage?.src ? (
				<Image
					src={backgroundImage.src}
					width={backgroundImage.width}
					height={backgroundImage.height}
					sizes="100vw"
					priority
					className="supt-pageHeaderFull__backgroundImage"
				/>
			) : null}
		</div>
	);
};

PageHeader.slug = block.slug;
PageHeader.title = block.title;
